// extracted by mini-css-extract-plugin
export default {"info":"UserStatItem_info__01qSo","infoTilte":"UserStatItem_infoTilte__+Ur+J","infoNumber":"UserStatItem_infoNumber__MkRKJ"};